import { render, staticRenderFns } from "./multi-slide-marquee.vue?vue&type=template&id=f1cc4ec8&scoped=true&lang=pug"
import script from "./multi-slide-marquee.vue?vue&type=script&lang=coffee"
export * from "./multi-slide-marquee.vue?vue&type=script&lang=coffee"
import style0 from "./multi-slide-marquee.vue?vue&type=style&index=0&id=f1cc4ec8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cc4ec8",
  null
  
)

export default component.exports